import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import QrLookupActionChip from './QrLookupActionChip'
import QrLookupWidget from './QrLookupWidget'
import QrLookupWidgetConfiguration from './QrLookupWidgetConfiguration'
import { QR_JOB_DETAIL_FIELDS, QR_LOOKUP_FIELDS } from './qrLookupConfig'

/**
 * Registers the "QR Lookup" MOS widget: scans a MIC label, resolves the element in Sun and opens its
 * card with the associated drawings and documents.
 *
 * Not available without a device, unlike the diagnostic QR Reader: this widget acts, and both the
 * context check ("does this label belong to the work running here?") and the audit trail are about a
 * particular station.
 */
class QrLookupWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'QrLookupWidget'

  getName = () => 'QR Lookup'

  getIcon = () => DocumentScannerIcon

  createWidget = (props) => <QrLookupWidget {...props} />

  createPreviewWidget = (props) => <QrLookupWidget {...props} preview />

  // "Opens the job" beside the title with the Job detail action (RN26). The grid shows its own notice
  // instead of this whenever the configuration is invalid.
  getCustomHeader = (props) => <QrLookupActionChip data={props?.data ?? {}} />

  // Added as 3x3: the viewfinder needs a square-ish panel to read as one, and the button below it is
  // the size a gloved hand needs. No minimum and no maximum beyond the grid's own one cell — a station
  // that wants this widget tiny or full width is entitled to it, and the widget lays its empty state
  // down in a row when it is given two rows or fewer.
  size = { defaultW: 3, defaultH: 3 }

  // Without this override the base reads no size at all and the widget lands as 1x1: `size` is a field
  // of ours, and it is this call that feeds it to the grid.
  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }

  // Every key the widget saves, so getDefaultConfiguration seeds a new widget with all of them.
  getConfigurationInfo = () => [...QR_LOOKUP_FIELDS, ...QR_JOB_DETAIL_FIELDS]

  // Own form: the base one cannot hide the job options while the action is SHEET (RN2).
  createConfigurationWidget = (data, setData, t_) => (
    <QrLookupWidgetConfiguration data={data} setData={setData} t_={t_} />
  )
}

export default QrLookupWidgetProvider
